var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVectorEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32221 21.9014C4.39164 21.9014 4.46107 21.8928 4.53051 21.8843L10.3672 20.8745C10.4367 20.8617 10.5018 20.8318 10.5495 20.7804L25.265 6.2722C25.3995 6.13957 25.3995 5.92137 25.265 5.78874L19.4933 0.0984037C19.4282 0.034227 19.3414 0 19.246 0C19.1505 0 19.0637 0.034227 18.9986 0.0984037L4.28749 14.6023C4.23542 14.6537 4.20504 14.7136 4.19202 14.782L3.16788 20.5408C3.10279 20.9216 3.21996 21.2895 3.49335 21.5591C3.72335 21.7816 4.00976 21.9014 4.32221 21.9014ZM6.66123 15.9329L19.2547 3.52116L21.7976 6.02833L9.20422 18.4401L6.11879 18.9792L6.66123 15.9329ZM21.3073 27.3778H1.56224C0.69867 27.3778 0 26.6889 0 25.8375C0 24.9861 0.69867 24.2973 1.56224 24.2973H21.3073C22.1708 24.2973 22.8695 24.9861 22.8695 25.8375C22.8695 26.6889 22.1708 27.3778 21.3073 27.3778Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorEdit);
export default __webpack_public_path__ + "static/media/Vector_Edit.d35175d9d87d928d44752aaee9b51334.svg";
export { ForwardRef as ReactComponent };